import React from 'react';
import LogoHeader from './components/LogoHeader';
import HeaderButtons from './components/HeaderButtons';
import CarouselPlaceholder from './components/CarouselPlaceholder';
import PromoBoxes from './components/PromoBoxes';
import ChatIAComponent from './components/ChatIA';

function Home() {
  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', overflowX: 'hidden' }}>
      <LogoHeader />
      <HeaderButtons />
      <CarouselPlaceholder />
      <PromoBoxes />
      
      {/* Nuestro nuevo asistente virtual flotante */}
      <ChatIAComponent />
      
      <footer style={{ padding: '40px', textAlign: 'center', color: '#555', backgroundColor: '#000', fontSize: '12px' }}>
        © 2026 BAMBO EVENTOS
      </footer>
    </div>
  );
}

export default Home;